// extracted by mini-css-extract-plugin
module.exports = {"offsetAnchor":"ChangelogEntry_offsetAnchor__fjLyF"};